import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import EnterPage from "./pages/EnterPage";
import RadarPage from "./pages/RadarPage";
import QuestionPage from "./pages/QuestionPage";
import GiftPage from "./pages/GiftPage";
import "./App.css";

function NavigationGuard() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.setItem("wasReloaded", "true");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Check if page was reloaded
        const wasReloaded = sessionStorage.getItem("wasReloaded");
        if (wasReloaded === "true" && location.pathname !== "/") {
            sessionStorage.removeItem("wasReloaded");
            navigate("/", { replace: true });
        }

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [navigate, location]);

    return null;
}

function App() {
    return (
        <Router>
            <NavigationGuard />
            <Routes>
                <Route path="/" element={<EnterPage />} />
                <Route path="/radar" element={<RadarPage />} />
                <Route path="/question" element={<QuestionPage />} />
                <Route path="/gift" element={<GiftPage />} />
            </Routes>
        </Router>
    );
}

export default App;
